import {
	tenantStackCheckPoll,
	tenantStackCreate as tenantStackCreateAction,
} from '@Actions/tenantStack';
import { getValue } from '@Selectors';
import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

type SensorStatusCheckerReturn = {
	stackExists: boolean;
	stackCheckRunning: boolean;
	checkFailed: boolean;
	tenantStackCreate: () => void;
	tenantStackCheck: () => void;
};

export const useTenantStack = (): SensorStatusCheckerReturn => {
	const dispatch = useDispatch();

	const { tenantStack } = useSelector(getValue);
	const {
		check: { status: checkStatus, stackExists },
	} = tenantStack;

	const stackCheckRunning = useMemo(() => {
		return checkStatus === 'idle' || checkStatus === 'pending';
	}, [checkStatus]);

	const checkFailed = useMemo(
		() => checkStatus === 'rejected',
		[checkStatus],
	);

	const tenantStackCreate = () => {
		dispatch(tenantStackCreateAction({}));
	};

	const tenantStackCheck = () => {
		dispatch(tenantStackCheckPoll({ timeoutSec: 15 }));
	};

	return {
		stackExists,
		stackCheckRunning,
		tenantStackCreate,
		tenantStackCheck,
		checkFailed,
	};
};
